<script>
import TablePage from '@/found/components/table_page';
import DetailForm from '../form/detail.vue';

export default {
  extends: TablePage,
  name: 'main_list',
  components: {
    DetailForm,
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    setColumn(v) {
      const item = v;
      if (item.field === 'levelList') {
        item.search = 'true';
        item.title = '凤香档级';
        item.type = 'select';
        item.apiUrl = '/cps/fxh/terminalConfigurationRuleController/findSelect';
        item.multiple = true;
        item.optionsKey = {
          label: 'detailName',
          value: 'detailName',
        };
        item.isSearch = true;
        item.paramsName = 'detailName';
      }
      return item;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      if (['history_records'].includes(val.code)) {
        this.formConfig = {};
        this.formName = 'Form';
        if (val.code === 'history_records') {
          this.modalConfig.title = '历史记录';
          this.formName = 'DetailForm';
        }
        this.modalConfig.width = '70%';
        this.modalConfig.height = '600px';
        this.formConfig = {
          type: val.code,
          id: row.id || '',
          code: val.code || '',
          terminalCode: row.terminalCode || '',
          terminalType: row.type || '',
        };
        this.openFull();
      }
    },
  },
};
</script>
